import { render, staticRenderFns } from "./configLossToUser.vue?vue&type=template&id=54f2f97b&scoped=true&"
import script from "./configLossToUser.vue?vue&type=script&lang=js&"
export * from "./configLossToUser.vue?vue&type=script&lang=js&"
import style0 from "./configLossToUser.vue?vue&type=style&index=0&id=54f2f97b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f2f97b",
  null
  
)

export default component.exports